















import { Observer } from 'mobx-vue'
import { Component, Provide, Vue } from 'vue-property-decorator'

@Observer
@Component({
  components: {
    'farming-banner': () => import('../components/farming-banner.vue'),
    farms: () => import('../components/farms.vue')
  }
})
export default class extends Vue {}
